import Group from 'components/utils/Group'
import React from 'react'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import { themeClassName } from 'lib/theme/themeUtils'

const LuxPlusNotificationBannerWrapper = styled(Group)`
  padding: ${rem(16)};
  background-color: ${props => props.theme.palette.product.luxPlus.background};
  color: ${props => props.theme.palette.product.luxPlus.contrast};
`

interface Props extends React.PropsWithChildren {
  hideCta?: boolean
}

function LuxPlusNotificationBanner(props :Props) {
  const { children, hideCta = false } = props
  return <LuxPlusNotificationBannerWrapper
    className={themeClassName('inverse')}
    direction="vertical"
    tabletDirection="horizontal"
    verticalAlign="center"
    horizontalAlign="center"
    gap={4}
    tabletGap={20}
  >
    <LuxPlusLogo height={16} />
    <BodyText variant="medium" colour="neutral-one" align="center">{children}</BodyText>
    {!hideCta && <TextLink
      weight="bold"
      underline
      size="medium"
      wrap="no-wrap"
      target="_blank"
      to={`/${LUXURY_PLUS_PATHS.LANDING_PAGE}`}
    >
      Learn more
    </TextLink>}
  </LuxPlusNotificationBannerWrapper>
}

export default LuxPlusNotificationBanner
